var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('span',[(_vm.isRequired)?[_vm._v(" "+_vm._s(_vm.preparedLabel)),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")]),_vm._v(": ")]:[_vm._v(_vm._s(_vm.label))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }